var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classnames,on:{"click":_vm.handleClick}},[_c('div',{class:(_vm.ns + "__flexbox")},[(this.$slots.icon)?[_c('div',{class:(_vm.ns + "__icon")},[_vm._t("icon")],2)]:_vm._e(),_vm._v(" "),(this.$slots.label)?[_c('div',{class:(_vm.ns + "__label")},[_vm._t("label")],2)]:_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06f7a8d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Tabs/TabsNavItem.vue
// module id = O2W7
// module chunks = 1